import { useSyncLanguage } from 'ni18n';
import { useEffect } from 'react';

export const useLanguageHook = () => {
	const locale = typeof window !== 'undefined' && window.localStorage.getItem('lang');
	useSyncLanguage(locale ?? 'id-ID');

	useEffect(() => {
		const hasLanguageSetting = window.localStorage.getItem('lang');

		if (!hasLanguageSetting) {
			// Set the default language or get from the browser
			const defaultLanguage = 'id-ID'; // Example: 'en', 'de', etc.
			window.localStorage.setItem('lang', defaultLanguage);
		}
	}, []);
	return {};
};
